import { createAsyncSelectors } from '@lib/selectors';
import { ViewForm } from './ViewForm';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useEffect, useRef } from 'react';
import { useAction, useAsyncState, useOnUnmount } from '@hooks';
const updateViewSelectors = createAsyncSelectors((state) => state.core.dataDictionary.views.patch);
export const RenameView = ({ onCancel, onFinish, view }) => {
    const { isReceived, isRequested } = useAsyncState(updateViewSelectors);
    const updateView = useAction(coreActions.requestPatchCoreDataDictionaryViews);
    const resetUpdate = useAction(coreActions.resetPatchCoreDataDictionaryViews);
    const onFinishRef = useRef(onFinish);
    onFinishRef.current = onFinish;
    useOnUnmount(resetUpdate);
    useEffect(() => {
        if (isReceived) {
            onFinishRef.current();
        }
    }, [isReceived]);
    return (React.createElement(ViewForm, { currentName: view.name, onCancel: onCancel, onSubmit: (viewName) => {
            updateView({
                viewId: view.id,
                viewName: viewName === null || viewName === void 0 ? void 0 : viewName.trim()
            });
        }, processing: isRequested }));
};
